import React from 'react';
import { withTranslation } from 'react-i18next';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import Card from '@material-ui/core/Card';
import CircularProgress from '@material-ui/core/CircularProgress';
import PrinterMap from './PrinterMap';

const SelectPrinterDialog = ({ open, loading, printers, apiKey, onPrinterSelected, t }) => {
  return (
    <Dialog
      open={open}
      onClose={() => {}}
      disableBackdropClick
      disableEscapeKeyDown
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>{t('choosePrinter')}</DialogTitle>
      <DialogContent>
        <DialogContentText />
        {loading && (
          <Card style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400 }}>
            <CircularProgress />
          </Card>
        )}
        {!loading && (
          <PrinterMap
            apiKey={apiKey}
            printers={printers}
            loading={false}
            onPrinterSelected={onPrinterSelected}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default withTranslation()(SelectPrinterDialog);

